import React from 'react';
import style from './ListAdmin.module.css';
import CardActiveContainer from '../../Components/CardActiveAdminContainer/CardActiveAdminContainer'
const ListAdmin = () => {
  return (
    <div className={style.container}>
    <CardActiveContainer/>
    
    </div>
  );
};

export default ListAdmin;